import React from 'react';

export const Download = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.65625 14.9062H13.7812M4.21875 7.59375L8.71875 11.5312M8.71875 11.5312L13.2188 7.59375M8.71875 11.5312V1.96875"
      stroke={color || '#535079'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
